import React from "react";
import { Dropdown } from "react-bootstrap";
import { ArrowRightIcon, CalendarIcon, CardIcon, CheckCircleIcon, ChevronDownIcon, ChevronUpIcon, CreditCardIcon, HolderIcon, InfoIcon, InvoiceIcon, PlusIcon, LockIcon, RetryIcon, StatusSuccessIcon } from "../modals/icons/icons";

export default function SubscriptionSummaryAndPayment({
    planData,
    quoteLoading,
    hasFormChanges,
    summaryData,
    money,
    selectedPlanName,
    formatDate,
    getTotalPrice,
    handlePayment,
    loading,
    paymentMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    newCardData,
    setNewCardData,
    errors,
    validateCardData,
    getSelectedPlanObj,
    isBlockedByPendingChanges,
    handleRevertPendingChange
}) {

    const planInfo = summaryData?.change_summary?.calculation_detail?.new_plan_info;
    const usersInfo = summaryData?.change_summary?.calculation_detail?.extra_users_info;
    const hasPlanInfo = !!planInfo;
    const hasUsersInfo = !!usersInfo;
    const showBoth = hasPlanInfo && hasUsersInfo;

    const canProceedToPayment =
        !loading &&
        !quoteLoading &&
        (hasFormChanges() || summaryData);

    return (
        <div className="col-lg-5">
            {loading ? (
                <>
                    <div className="subscription-edit-summary card mb-4 d-flex flex-column gap-3 h-50 p-3">
                        <div className="loading-skeleton h-25" />
                        <div className="px-5 h-75">
                            <div className="loading-skeleton h-100" />
                        </div>
                    </div>
                    <div className="subscription-edit-payment-methods p-3 pt-0 d-flex flex-column h-25 gap-3">
                        <div className="loading-skeleton h-50" />
                        <div className="loading-skeleton h-25" />
                        <div className="loading-skeleton h-25" />
                    </div>
                </>
            ) : (
                <>
                    <div className="subscription-edit-summary card mb-4 d-flex flex-column gap-3">
                        <h5 className="subscription-edit-section-title d-flex align-items-center p-3 gap-2 m-0">
                            <CheckCircleIcon />
                            Resumen del cambio
                        </h5>
                        {quoteLoading ? (
                            <div className="p-5 pt-0">
                                <div className="subscription-edit-summary-empty d-flex flex-column align-items-center justify-content-center gap-3">
                                    <div className="subscription-edit-summary-empty-icon d-flex text-center align-items-center justify-content-center">
                                        <div className="p-5 d-flex justify-content-center align-items-center">
                                            <div className="spinner-border text-secondary" role="status">
                                                <span className="visually-hidden">Cargando...</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="subscription-edit-summary-empty-text d-flex flex-column align-items-center justify-content-center gap-3">
                                        Cargando información...
                                        <span>
                                            Por favor, espera a que se cargue la información.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ) : (hasFormChanges() || summaryData?.is_scheduled) && summaryData ? (
                            <>
                                <div className="subscription-edit-price d-flex flex-row align-items-center justify-content-between px-5">
                                    <span>
                                        Plan {summaryData.change_summary.new_plan || selectedPlanName || "—"}
                                    </span>
                                    <span>
                                        {summaryData.change_summary.calculation_detail
                                            ? (() => {
                                                const detail = summaryData.change_summary.calculation_detail;

                                                const desired =
                                                    detail.new_plan_info?.desired_change_value ??
                                                    detail.extra_users_info?.desired_change_value ??
                                                    money(getTotalPrice());

                                                const cycle =
                                                    detail.new_plan_info?.new_cycle ??
                                                    detail.extra_users_info?.new_cycle ?? // normalment no tiene cycle
                                                    "";

                                                return `${desired}${cycle ? ` / ${cycle}` : ""}`;
                                            })()
                                            : money(getTotalPrice())
                                        }
                                    </span>

                                </div>

                                <div className="subscription-edit-calculation px-5">
                                    <div className="d-flex justify-content-between align-items-center subscription-edit-calculation-collapse px-2" data-bs-toggle="collapse" data-bs-target="#calculation-details" aria-expanded="true" aria-controls="calculation-details">
                                        <span className="d-flex align-items-center gap-2">
                                            <InvoiceIcon />
                                            <span className="subscription-edit-calculation-title">
                                                Detalle del cálculo
                                            </span>
                                        </span>
                                        <span data-feather="chevron-up">
                                            <ChevronUpIcon />
                                        </span>
                                    </div>

                                    <div
                                        className="subscription-edit-calculation-details d-flex flex-column gap-2 collapse show px-4 pt-2 pb-4"
                                        id="calculation-details"
                                    >
                                        <p className="mb-0 subscription-edit-calculation-details-title">
                                            Cobertura del cambio proporcional:
                                        </p>

                                        <div className="subscription-edit-calc-title d-flex justify-content-between">
                                            <div className="d-flex flex-column gap-1 justify-content-start">
                                                <span>Inicio del cambio</span>
                                                <span className="d-flex flex-row justify-content-center align-items-center gap-1 subscription-edit-calc-title-date">
                                                    <CalendarIcon />
                                                    {summaryData.change_summary.calculation_detail.coverage.change_start}
                                                </span>
                                            </div>

                                            <ArrowRightIcon />

                                            <div className="d-flex flex-column gap-1 justify-content-start">
                                                <span>Nueva Renovación</span>
                                                <span>
                                                    {summaryData.change_summary.calculation_detail.coverage.new_renewal}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="subscription-edit-calc-values d-flex flex-column gap-2">

                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <span>Nuevo precio por usuario:</span>
                                                <span className="calc-value">
                                                    {summaryData.change_summary.calculation_detail.calculation_data.new_price_per_user}
                                                </span>
                                            </div>

                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <span>Cantidad de usuarios:</span>
                                                <span className="calc-value">
                                                    {summaryData.change_summary.calculation_detail.calculation_data.users_count}
                                                </span>
                                            </div>

                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <span>Cantidad de administrativos:</span>
                                                <span className="calc-value">
                                                    {summaryData.change_summary.calculation_detail.calculation_data.admins_count}
                                                </span>
                                            </div>

                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <span>Pago realizado:</span>
                                                <span className="calc-value">
                                                    {summaryData.change_summary.calculation_detail.calculation_data.paid_amount}
                                                </span>
                                            </div>

                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <span>Días del plan:</span>
                                                <span className="calc-value">
                                                    {summaryData.change_summary.calculation_detail.calculation_data.plan_total_days}
                                                </span>
                                            </div>

                                            {(() => {
                                                const planInfo = summaryData.change_summary.calculation_detail.new_plan_info;
                                                const usersInfo = summaryData.change_summary.calculation_detail.extra_users_info;

                                                const hasPlanInfo = !!planInfo;
                                                const hasUsersInfo = !!usersInfo;
                                                const showBoth = hasPlanInfo && hasUsersInfo;

                                                return (hasPlanInfo || hasUsersInfo) ? (
                                                    <div className="summary-box-blue p-2 d-flex flex-column gap-2">

                                                        {hasPlanInfo && (
                                                            <>
                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Nuevo ciclo:</span>
                                                                    <span className="calc-value">{planInfo.new_cycle}</span>
                                                                </div>

                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Plan:</span>
                                                                    <span className="calc-value">{planInfo.new_plan}</span>
                                                                </div>

                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Fecha de solicitud:</span>
                                                                    <span className="calc-value">{planInfo.request_date}</span>
                                                                </div>

                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Días restantes del plan:</span>
                                                                    <span className="calc-value">{planInfo.remaining_days}</span>
                                                                </div>

                                                                {!showBoth && (
                                                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                                                        <span className="calc-title">Valor de próxima renovación:</span>
                                                                        <span className="calc-value">{planInfo.desired_change_value}</span>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}

                                                        {hasUsersInfo && (
                                                            <>
                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Usuarios extra:</span>
                                                                    <span className="calc-value">{usersInfo.extra_clients}</span>
                                                                </div>

                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Admins extra:</span>
                                                                    <span className="calc-value">{usersInfo.extra_admins}</span>
                                                                </div>

                                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                                    <span className="calc-title">Días restantes del plan:</span>
                                                                    <span className="calc-value">{usersInfo.remaining_days}</span>
                                                                </div>

                                                                {!showBoth && (
                                                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                                                        <span className="calc-title">Valor de próxima renovación:</span>
                                                                        <span className="calc-value">{usersInfo.desired_change_value}</span>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}

                                                        {showBoth && (
                                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                                <span className="calc-title">Valor de próxima renovación:</span>
                                                                <span className="calc-value">
                                                                    {planInfo.desired_change_value}
                                                                </span>
                                                            </div>
                                                        )}

                                                    </div>
                                                ) : null;
                                            })()}

                                            {summaryData.change_summary.calculation_detail.credit_value && (
                                                <div className="summary-box-green p-2 d-flex flex-row justify-content-between align-items-center">
                                                    <span className="calc-title">Valor a favor:</span>
                                                    <span className="calc-value">
                                                        {summaryData.change_summary.calculation_detail.credit_value}
                                                    </span>
                                                </div>
                                            )}

                                            <div className="d-flex flex-row justify-content-between align-items-center">
                                                <span className="calc-title">Valor total a pagar hoy:</span>
                                                <span className="calc-value">
                                                    {summaryData.change_summary.total_to_pay_today}
                                                </span>
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <div className="px-4">
                                    <div className="subscription-edit-divider" />
                                </div>

                                <div className="d-flex flex-row justify-content-around align-items-end px-5">
                                    <span className="subscription-edit-total-label">Total a pagar hoy</span>
                                    <span className="subscription-edit-total">
                                        {summaryData.is_scheduled ? "COP $0" : summaryData.change_summary.total_to_pay_today}
                                    </span>
                                </div>

                                <div className="px-4 pb-4">
                                    <div className="subscription-edit-summary-alert p-2 d-flex flex-row align-items-center gap-2" role="alert">
                                        <InfoIcon />
                                        <span>
                                            {summaryData.is_scheduled
                                                ? `Este cambio se aplicará automáticamente el ${summaryData.change_summary.calculation_detail.coverage.change_start}. No se realizará ningún cobro hoy.`
                                                : "Este cambio será efectivo inmediatamente al finalizar la compra. Recuerda que el valor cobrado es el prorrateado por los días restantes de tu plan actual"
                                            }
                                        </span>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="p-5 pt-0">
                                <div className="subscription-edit-summary-empty d-flex flex-column align-items-center justify-content-center gap-3">
                                    <div className="subscription-edit-summary-empty-icon d-flex text-center align-items-center justify-content-center">
                                        <StatusSuccessIcon />
                                    </div>
                                    <div className="subscription-edit-summary-empty-text d-flex flex-column align-items-center justify-content-center gap-3">
                                        Tu plan está actualizado
                                        <span>
                                            No has realizado ninguna modificación en tu suscripción actual.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="subscription-edit-payment-methods p-3 pt-0 d-flex flex-column gap-3">
                        <h5 className="subscription-edit-section-title d-flex align-items-center gap-2 m-0">
                            <CreditCardIcon />
                            Selecciona un método de pago
                        </h5>

                        {paymentMethods.map(method => (
                            <div
                                key={method.id}
                                className={`payment-method-item d-flex justify-content-between align-items-center p-3 ${selectedPaymentMethod === method.id ? 'selected' : ''}`}
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <input
                                        type="radio"
                                        name="payment-method"
                                        checked={selectedPaymentMethod === method.id}
                                        onChange={() => setSelectedPaymentMethod(method.id)}
                                    />
                                    <div className="d-flex flex-column">
                                        <span className="payment-card-title">{method.label}</span>
                                        <span className="payment-card-subtitle">Vence {method.expiration}</span>
                                    </div>
                                </div>
                                <div className="payment-card-actions d-flex align-items-center gap-3">
                                    {method.is_default && <span className="payment-default">Predeterminado</span>}
                                    <CardIcon />
                                </div>
                            </div>
                        ))}

                        <div className={`payment-method-add d-flex justify-content-between align-items-center p-3 ${selectedPaymentMethod === "new" ? 'selected' : ''}`}>
                            <div className="d-flex align-items-center gap-3">
                                <input
                                    type="radio"
                                    name="payment-method"
                                    checked={selectedPaymentMethod === "new"}
                                    onChange={() => setSelectedPaymentMethod("new")}
                                />
                                <span className="payment-add-text">Usar otro método de pago</span>
                            </div>
                            <PlusIcon />
                        </div>

                        {selectedPaymentMethod === "new" && (
                            <>
                                <div className="subscription-holder-info card p-3 d-flex flex-column gap-3">
                                    <h5 className="subscription-edit-section-title d-flex align-items-center gap-2 m-0">
                                        <HolderIcon />
                                        Información del titular
                                    </h5>

                                    <div className="d-flex flex-column gap-2">
                                        <label className="form-label">Nombre completo (como aparece en la tarjeta)</label>
                                        <input
                                            type="text"
                                            className={`form-control subscription-edit-input ${errors.holder_name ? "is-invalid" : ""}`}
                                            placeholder="Ej. Andrés Forero"
                                            value={newCardData.holder_name}
                                            onChange={(e) => setNewCardData({ ...newCardData, holder_name: e.target.value })}
                                        />
                                        {errors.holder_name && <small className="text-danger">{errors.holder_name}</small>}
                                    </div>

                                    <div className="d-flex flex-column flex-md-row gap-3">
                                        <div className="w-50 d-flex flex-column gap-2">
                                            <label className="form-label">Tipo de documento</label>
                                            <Dropdown className="subscription-edit-select">
                                                <Dropdown.Toggle className="w-100 d-flex justify-content-between align-items-center subscription-edit-dropdown-btn">
                                                    {newCardData.document_type}
                                                    <ChevronDownIcon />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="subscription-edit-select-menu w-100">
                                                    <Dropdown.Item onClick={() => setNewCardData({ ...newCardData, document_type: "Cédula de Ciudadanía" })}>
                                                        Cédula de Ciudadanía
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setNewCardData({ ...newCardData, document_type: "Cédula de Extranjería" })}>
                                                        Cédula de Extranjería
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => setNewCardData({ ...newCardData, document_type: "Pasaporte" })}>
                                                        Pasaporte
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                        <div className="w-50 d-flex flex-column gap-2">
                                            <label className="form-label">Número de documento</label>
                                            <input
                                                type="text"
                                                className={`form-control subscription-edit-input ${errors.document_number ? "is-invalid" : ""}`}
                                                placeholder="Ej. 123456789"
                                                value={newCardData.document_number}
                                                onChange={(e) => setNewCardData({ ...newCardData, document_number: e.target.value })}
                                            />
                                            {errors.document_number && <small className="text-danger">{errors.document_number}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="subscription-payment-info card p-3 d-flex flex-column gap-3">
                                    <h5 className="subscription-edit-section-title d-flex align-items-center gap-2 m-0">
                                        <CreditCardIcon className="subscription-edit-section-title-icon" />
                                        Método de pago
                                    </h5>

                                    <div className="d-flex flex-column gap-2">
                                        <label className="form-label">Número de tarjeta</label>
                                        <input
                                            type="text"
                                            className={`form-control subscription-edit-input ${errors.card_number ? "is-invalid" : ""}`}
                                            placeholder="0000 0000 0000 0000"
                                            value={newCardData.card_number}
                                            onChange={(e) => setNewCardData({ ...newCardData, card_number: e.target.value })}
                                        />
                                        {errors.card_number && <small className="text-danger">{errors.card_number}</small>}
                                    </div>

                                    <div className="d-flex flex-column flex-md-row gap-3">
                                        <div className="w-50 d-flex flex-column gap-2">
                                            <label className="form-label">Vencimiento (MM/AA)</label>
                                            <input
                                                type="text"
                                                className={`form-control subscription-edit-input ${errors.expiration ? "is-invalid" : ""}`}
                                                placeholder="MM/AA"
                                                value={newCardData.expiration}
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/\D/g, "");
                                                    if (value.length > 4) value = value.slice(0, 4);
                                                    if (value.length >= 2 && e.nativeEvent.inputType !== 'deleteContentBackward') {
                                                        value = `${value.slice(0, 2)}/${value.slice(2)}`;
                                                    }
                                                    setNewCardData({ ...newCardData, expiration: value });
                                                }}
                                            />
                                            {errors.expiration && <small className="text-danger">{errors.expiration}</small>}
                                        </div>

                                        <div className="w-50 d-flex flex-column gap-2">
                                            <label className="form-label">CVV</label>
                                            <input
                                                type="text"
                                                className={`form-control subscription-edit-input ${errors.cvv ? "is-invalid" : ""}`}
                                                placeholder="123"
                                                value={newCardData.cvv}
                                                onChange={(e) => setNewCardData({ ...newCardData, cvv: e.target.value })}
                                            />
                                            {errors.cvv && <small className="text-danger">{errors.cvv}</small>}
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center gap-2 mt-2">
                                        <input
                                            type="checkbox"
                                            checked={newCardData.save_card}
                                            onChange={(e) => setNewCardData({ ...newCardData, save_card: e.target.checked })}
                                        />
                                        <span>Guardar tarjeta para futuros pagos de manera segura.</span>
                                    </div>
                                </div>
                            </>
                        )}

                        <button
                            className={`subscription-edit-pay-btn w-100 d-flex justify-content-center align-items-center ${isBlockedByPendingChanges ? "pending-changes" : ""}`}
                            onClick={isBlockedByPendingChanges ? handleRevertPendingChange : handlePayment}
                            disabled={!canProceedToPayment}
                        >
                            {loading ? (
                                "Procesando..."
                            ) : isBlockedByPendingChanges ? (
                                <>
                                    <RetryIcon />
                                    Revertir cambio pendiente
                                </>
                            ) : !canProceedToPayment ? (
                                "Guardar"
                            ) : (
                                <>
                                    <LockIcon />
                                    {summaryData?.is_scheduled
                                        ? "Programar cambio"
                                        : `Pagar ${summaryData?.change_summary?.total_to_pay_today || money(getTotalPrice())}`
                                    }
                                </>
                            )}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}